export const stripe = {
  subTitle:
    "Verknüpfen Sie Ihr Stripe-Konto, um Ihren Kunden Buchungen schnell und einfach in Rechnung zu stellen und Provisionen der Online-Reisebüros zu vermeiden.",
};
